export default __webpack_public_path__ + "locales/es/FormGallery.json?hash=24fdfe6f02420e878c09b9133b165f89";